const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/administrative/EmptyRouterView.vue");
const Admision = () => /* webpackChunkName: "Home" */ import("./../views/admision/Home.vue");
const ArchiveRequest = () => /* webpackChunkName: "ArchiveRequestHome" */ import("./../views/admision/archive_request/ArchiveRequestHome.vue");
const Archive = () => /* webpackChunkName: "Archive" */ import("./../views/admision/archive/Archive.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/admision",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "admisionHome",
        component: Admision,
      },
      {
        path: "solicitud-archivo",
        name: "ArchiveRequest",
        component: ArchiveRequest,
      },
      // {
      //   path:'admisionArchiveRequest',
      //   name:'administrativePatientHome',
      //   component:PatientHome
      // },
      // {
      //   path:'solicitud-archivo',
      //   name:'administrativeArchiveRequest',
      //   component:ArchiveRequest
      // },
      {
        path: "archivo",
        name: "admisionArchive",
        component: Archive,
      },
      {
        path: "documentacion",
        name: "admisionDocumentation",
        component: Document,
      },
    ],
  },
];
